module.exports = __webpack_public_path__ + "img/lcs-logo1-50x20.db788ce8.png";